import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import FilterItem, { IFilterItem } from './filterItem';
import { ReactComponent as FilterIcon } from '$/assets/icons/filter.svg';
import { ReactComponent as SortIcon } from '$/assets/icons/sort.svg';
import * as Bixby from '$/core';
import './index.scss';

export interface ISortItem<T> {
  value: keyof T;
  name: string;
}

interface ISortFilterProps {
  filters: IFilterItem[];
  sorts?: Array<ISortItem<any>>;
  multiselect?: boolean;
  onFilter: (id: string, futureState: boolean) => void;
  onClearFilters: () => void;
  onSort?: (event: React.FormEvent<HTMLSelectElement>, id: any) => void;
}

const SortFilter: React.FC<ISortFilterProps> = props => {
  const { sorts, multiselect = true, onFilter, onClearFilters, onSort } = props;
  const [filterActiveToggle, setFilterActiveToggle] = useState(false);
  const [sortActiveToggle, setSortActiveToggle] = useState(false);
  const [filters, setFilters] = useState([] as IFilterItem[]);

  const handleFilterActiveToggle = () => {
    setFilterActiveToggle(!filterActiveToggle);
  };

  const handleSortActiveToggle = () => {
    setSortActiveToggle(!sortActiveToggle);
  };

  const handleSortChange = (event: React.FormEvent<HTMLSelectElement>) => {
    if (onSort) {
      const value = event.currentTarget.value;
      onSort(event, value);
    }
  };

  const handleClearFilters = () => {
    for (let i = 0; i < filters.length; i++) {
      filters[i].active = false;
    }
    setFilters([...filters]);

    onClearFilters();
  };

  const handleOnFilter = (id: string, futureState: boolean) => {
    if (!multiselect) {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (filter.id !== id) {
          filter.active = false;
        } else {
          filter.active = futureState;
        }
      }
    } else {
      const indexOfFilter = filters.findIndex(_ => _.id === id);
      filters[indexOfFilter].active = futureState;
      setFilters([...filters]);
    }

    onFilter(id, futureState);
  };

  useEffect(() => {
    setFilters(props.filters);
  }, [props.filters]);

  return (
    <div className="filter_sort">
      <div className="filter_section">
        <div onClick={handleFilterActiveToggle}>
          <div className="label">
            <div className="icon_wrap filter">
              <FilterIcon />
            </div>
            Filter By:
          </div>
        </div>
        <div className={classNames('filter_sort_modal', { active: filterActiveToggle })}>
          <div className="modal_box">
            <div className="modal_headline">
              <div>Filters</div>
              <div className="clear_all" onClick={handleClearFilters} role="button">
                Clear All
              </div>
              <button className="modal_close" onClick={handleFilterActiveToggle} role="button">
                X
              </button>
            </div>
            <div className="modal_main_content">
              <div className="modal_title">Documents</div>
              <div className="filter_items">
                {filters &&
                  filters.map((filter, ix) => {
                    return <FilterItem key={ix} filter={filter} onFilter={handleOnFilter} />;
                  })}
              </div>
            </div>
            <div className="modal_apply" onClick={handleFilterActiveToggle}>
              Apply Selection
            </div>
          </div>
        </div>
      </div>
      {!Bixby.Utils.isNullOrEmpty(sorts) && (
        <div className="sort_section">
          <div onClick={handleSortActiveToggle}>
            <div className="label">
              <div className="icon_wrap sort">
                <SortIcon />
              </div>
              Sort By:
            </div>
          </div>
          <div className={classNames('filter_sort_modal', { active: sortActiveToggle })}>
            <div className="modal_box">
              <div className="modal_headline">
                <div>Filters</div>
                <button className="modal_close" onClick={handleSortActiveToggle}>
                  X
                </button>
              </div>
              <div className="modal_main_content">
                <div className="modal_title">View</div>
                <div className="sort_select_wrap">
                  <select onChange={handleSortChange}>
                    {sorts &&
                      sorts.map((sort, ix) => {
                        return (
                          <option key={ix} value={sort.value.toString()}>
                            {sort.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <button className="modal_apply" onClick={handleSortActiveToggle}>
                Apply Selection
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SortFilter;
